import { render, staticRenderFns } from "./ServicesRequested.vue?vue&type=template&id=48ff4004&scoped=true"
import script from "./ServicesRequested.vue?vue&type=script&lang=js"
export * from "./ServicesRequested.vue?vue&type=script&lang=js"
import style0 from "./ServicesRequested.vue?vue&type=style&index=0&id=48ff4004&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ff4004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ff4004')) {
      api.createRecord('48ff4004', component.options)
    } else {
      api.reload('48ff4004', component.options)
    }
    module.hot.accept("./ServicesRequested.vue?vue&type=template&id=48ff4004&scoped=true", function () {
      api.rerender('48ff4004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/sections/ServicesRequested.vue"
export default component.exports